/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useMemo, useState, useRef, useCallback } from 'react';
import clsx from 'clsx';
import { Styled } from './index.styles';
import { PropertyCardDetailsProps } from '../../organisms/SearchResults/index.types';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import CommonUtils from '../../organisms/SearchResults/lib/CommonUtils';
import { getClassForBreakpoint, useGetBreakpoint, eventUtil } from '@marriott/mi-ui-library-shop';
import { NAVIGATION_URL_CONSTANTS } from '../../organisms/SearchResults/lib/config';
import {
  Modal,
  LogoContainer,
  LogoContainerBackgroundColor,
  Badge,
  BadgeVariation,
  Types,
} from '@marriott/mi-ui-library';
import { useHQVContext } from '../../context';
import { HQV_ACTIONS } from '../../reducers';
import {
  DefaultValue,
  HWSBrands,
  descriptionToDisplayOnPropertyCard,
  descriptionToDisplayOnPropertyCardChat,
  studioResCode,
  studisResCodeAriaLabel,
} from '../../organisms/SearchResults/index.constant';
import {
  SearchFilterContext,
  SearchResultAlertContext,
  SearchResultContext,
} from '../../organisms/SearchResults/index.context';
import {
  getPriceByDecimalPoint,
  getCurrentPriceRateBlock,
  getCurrRateAmountBlock,
  updateDatalayerObjViewRates,
  getCurrentRatePointsBlock,
  getRateBlock,
  enableHotelList,
  constructAdfOrRlmURL,
} from '../../organisms/SearchResults/lib/helper';
import {
  addSubDirectoryPrefix,
  getCalculatedDistance,
  formatNumberByLocale,
  isReviewCountHidden,
  dttRatesTransformer,
  dttDescriptionTransformer,
  handlePropertyClicked,
} from '../../utils';
import { PageContext, usePageContext } from '../../context/PageContext/index';
import { hardCodedAllLocale } from '../../organisms/SearchResults/index.constant';
import { localeToShowAllInclusiveBadge, reviewsRedirectionVarValue, trcRedirectionVarValue } from '../../constants';
import { useCheckBreakpoint, useRedirectionRules } from '../../hooks';
import SM from '../../organisms/HotelGalleryTitle/config';
import { TOOLTIP_POSITION, PropertyReview, PropertyRatingContainer, CN_RATING_TOOLTIP } from '@marriott/mi-ui-library';
import { isJpKoCnLocale } from '@marriott/shared/mi-helper-utils';
import { useSearchResultsStore } from '../../modules/store/searchResultsStore';
import {
  constructMandatoryFeeTitle,
  constructToolTipData,
  determineIfRatesPresent,
  fetchAndSetSelectedPropertyData,
  getHotelCodeUnavailable,
  getPriceInfo,
  getToolTipData,
  getTotalPrice,
  hotelUnavailableOrMaxOccupied,
  identifyTypeOfMandatoryFee,
  mandatoryFeeAvailable,
} from '../../modules/utils/ratesHelper';
import { EEO_TYPE, SEARCH_RESULTS_ALERTS } from '../../modules/constants';
import { PropertyCardPriceSection } from '../propertyCardPriceComponent';
import { ImageCarouselComponent } from '../imageCarousel';
import { formatOpeningSoonDate } from '../../modules/utils';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    // extends React's HTMLAttributes
    custom_click_track_value?: string;
  }
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>;
    _satellite: Record<string, any>;
  }
}

export const PropertyCardComponent: React.FC<PropertyCardDetailsProps> = ({
  propertyCardData: propertyCardDataProps,
  idx,
  handlePopUpOpen,
  pageNumber,
  noRatesAvailableForAnyProperty,
  propertyHandleStaleError = false,
  onOpenHotelPanel,
}) => {
  const {
    jsonContent,
    isMapViewEnabled,
    recentlyViewed,
    setRecentlyViewed,
    continueCtaProperty,
    isFlexibleDateSearch,
    setFeatureSelected,
    isSpecialRateSearch,
    isErrorState,
    setIsErrorState,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any = useContext(renderedData);
  const { searchQueryState } = useContext(SearchFilterContext);

  const {
    currentLocale,
    SESSION_APP_GET_CALL_URL,
    headersData,
    isDTT,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    sessionData,
    featureFlagLogo,
    pageVal,
  } = usePageContext();
  const disableHotelHeaderAndReviewLinks = jsonContent?.disableHotelHeaderAndReviewLinks;
  const disableHotelReviewLinks = jsonContent?.disableHotelReviewLinks ?? false;
  const [recentlyViewedFlag, setRecentlyViewedFlag] = useState(false);
  const { searchResultAlerts } = useContext(SearchResultAlertContext);
  const { searchResult } = useContext(SearchResultContext);
  const [popupOpenState, setPopupOpenState] = useState(false);
  const [showStrikeThroughPrice, setShowStrikeThroughPrice] = useState<boolean>(false);
  const [breakpoint, setBreakpoint] = useState<string | undefined>(useGetBreakpoint());
  const [finalPrice, setFinalPrice] = useState<string | undefined>('');
  const [hqvModalState, setHQVModalFlag] = useState(false);
  const propertyNameRef = useRef<HTMLButtonElement>(null);
  const ratingContainer = isReviewCountHidden(currentLocale)
    ? 'rating-container is-review-count-hidden'
    : 'rating-container';
  const { currentCurrency, search, includeTaxesAndFees } = searchQueryState;

  useEffect(() => {
    setSearchResultsState([SEARCH_RESULTS_ALERTS], {
      [SEARCH_RESULTS_ALERTS]: { [SEARCH_RESULTS_ALERTS]: searchResultAlerts },
    });
  }, [searchResultAlerts]);
  //call the MGP transformer here if mgp flag is false, to transform the old response to new response
  //TODO : isDTT to be changed to isDTTFlag , mgp to be changed to dtt post backend changes are ready

  const propertyCardData = useMemo(() => {
    const tempPropertyCardData = JSON.parse(JSON.stringify(propertyCardDataProps)); //deep clone the propery data
    if (!isDTT) {
      const newMGPRatesBlock = dttRatesTransformer(tempPropertyCardData?.node?.rates);
      tempPropertyCardData.node.rates = newMGPRatesBlock;
      if (tempPropertyCardData?.node?.property?.basicInformation?.descriptions) {
        const newMGPDescriptionBlock = dttDescriptionTransformer(
          tempPropertyCardData?.node?.property?.basicInformation?.descriptions
        );
        tempPropertyCardData.node.property.basicInformation.descriptions = newMGPDescriptionBlock;
      }
    }
    return tempPropertyCardData;
  }, [propertyCardDataProps]);
  const propertyData = isFlexibleDateSearch ? propertyCardData?.node : propertyCardData?.node?.property;
  const isMax = propertyData?.basicInformation?.isMax;
  const { hqvState, hqvDispatch } = useHQVContext();
  const currRateNode = getCurrentPriceRateBlock(searchQueryState, propertyCardData?.node?.rates);
  const currRateDetails = getCurrRateAmountBlock(currRateNode);
  const host = headersData?.['x-host'];
  const bodyRef = useRef<HTMLBodyElement | null>(null);
  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);
  const priceInfo = getPriceInfo(currRateDetails, true, isFlexibleDateSearch);

  const isViewportL = useCheckBreakpoint('viewportL');
  const isViewportS = useCheckBreakpoint('viewportS');
  const handlePropertyCardHover = (result: any): void => {
    if (isMapViewEnabled) {
      eventUtil.dispatch('propCardOver', result);
    }
  };

  const handlePropertyCardUnhover = (): void => {
    if (isMapViewEnabled) {
      eventUtil.dispatch('propCardUnOver', []);
    }
  };
  const getMapViewRatingClass = useCallback(
    () => getClassForBreakpoint(breakpoint, 't-font-alt-xs', 't-font-alt-xs', 't-font-alt-xs'),
    [breakpoint]
  );
  const getListViewRatingClass = useCallback(
    () => getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-xs', 't-font-alt-xs'),
    [breakpoint]
  );
  function isDateAfterToday(dateString: string): boolean {
    const year = +dateString.substring(0, 4);
    const month = +dateString.substring(5, 7);
    const day = +dateString.substring(8, 10);
    const date = new Date(year, month - 1, day);
    return new Date(date.toDateString()) > new Date(new Date().toDateString());
  }

  const basicInformation = propertyData?.basicInformation;
  const otherPropertyInformation = propertyData?.otherPropertyInformation;
  const media = propertyData?.media;
  const reviewInfo = propertyData?.reviews;
  const clickTrackingLoc = 'Phoenix Search Results';
  const propertyID = propertyData?.id ?? '';
  const seoNickName = propertyData?.seoNickname ?? null;
  const brandCode = basicInformation?.brand?.id;
  const isFullyRenovated = basicInformation?.isFullyRenovated;
  const hasRenovatedRooms = basicInformation?.hasRenovatedRooms;
  const newLobby = basicInformation?.newLobby;
  const newProperty = basicInformation?.newProperty;
  const isRecentlyRenovated = basicInformation?.isRecentlyRenovated;
  const nameInDefaultLanguage = basicInformation?.nameInDefaultLanguage;
  const pointsRateBlock = getRateBlock(propertyCardData?.node?.rates, 'points');
  const eeoRateBlock = getRateBlock(propertyCardData?.node?.rates, EEO_TYPE);
  //TAXANDFEENEW : setting total price to null if taxes and fee toggle is off
  const totalPrice = getTotalPrice(currRateDetails, isFlexibleDateSearch, includeTaxesAndFees);
  const pointsBlock = isFlexibleDateSearch ? null : getCurrentRatePointsBlock(propertyCardData?.node?.rates);
  const pointsValue = pointsBlock?.points;
  const openingDate = basicInformation?.openingDate;
  const isFutureDate = openingDate ? isDateAfterToday(openingDate) : false;
  const isHotelBookable = basicInformation?.bookable;
  const isHotelCodeUnavailable = getHotelCodeUnavailable(currRateNode, isFlexibleDateSearch, pointsRateBlock);

  const mandatoryFeeResult = identifyTypeOfMandatoryFee(propertyData?.basicInformation);
  let { isResort } = mandatoryFeeResult;
  const { isLACountyFee, isDestinationFee } = mandatoryFeeResult;

  const setSearchResultsState = useSearchResultsStore(
    (state: { setSearchResultsState: any }) => state.setSearchResultsState
  );
  const ratesData = useSearchResultsStore((state: { ratesData: any }) => state.ratesData);
  //if still isResort flag is empty then use resort Flag from uxl
  if (isResort === '') {
    isResort = propertyData?.basicInformation?.resort;
  }
  const toolTipData = getToolTipData(propertyData);

  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  const toolTipList = toolTipData && toolTipData[0]?.text?.split('|').filter((item: string) => item.length > 0);

  const { toolTipTitle } = constructToolTipData(isResort, isLACountyFee, isDestinationFee, jsonContent);

  const adultsOnlyPropertyFlag = propertyData?.basicInformation?.isAdultsOnly;

  let edgeCaseTriggered = false;

  // get current points block for property card
  const currRatePoints = isFlexibleDateSearch ? null : getCurrentRatePointsBlock(propertyCardData?.node?.rates);
  const { options } = search;
  const childCount = options?.childAges?.length ?? 0;
  const isAdultOnlyEdgeCaseTriggered = propertyData?.basicInformation?.isAdultsOnly && childCount > 0;
  const newMandatFee = currRateDetails?.mandatoryFees;
  const pageContext = useContext(PageContext);

  const isMandatoryFeeAvailable = mandatoryFeeAvailable(
    currRateDetails,
    SM?.ALLOWED_DOMAINS?.includes(pageContext?.currentLocale as string),
    isFlexibleDateSearch
  );

  // check if rates are present
  const isRatesPresent: boolean = determineIfRatesPresent(currRatePoints, currRateDetails);

  //eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (recentlyViewed && recentlyViewed.length > 0) {
      localStorage.setItem('recent', recentlyViewed);
    }
  }, [recentlyViewed]);

  useEffect(() => {
    if (!hqvState.modalOpenState && hqvModalState) {
      propertyNameRef?.current?.focus();
      setHQVModalFlag(false);
    }
  }, [hqvState, hqvModalState]);

  // Reset breakpoint on window resize.
  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      setBreakpoint(useGetBreakpoint());
    }

    if (
      isErrorState &&
      (isMandatoryFeeAvailable ||
        (totalPrice?.amount && totalPrice?.amount > 0) ||
        (pointsValue && pointsValue > 0) ||
        priceInfo?.amount ||
        isFlexibleDateSearch ||
        noRatesAvailableForAnyProperty ||
        isHotelMaxOccupancyExceeded ||
        isHotelUnavailable ||
        isAdultOnlyEdgeCaseTriggered)
    ) {
      setIsErrorState(false);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (
      isErrorState &&
      (isMandatoryFeeAvailable ||
        (totalPrice?.amount && totalPrice?.amount > 0) ||
        (pointsValue && pointsValue > 0) ||
        priceInfo?.amount ||
        isFlexibleDateSearch ||
        noRatesAvailableForAnyProperty ||
        isHotelMaxOccupancyExceeded ||
        isHotelUnavailable ||
        isAdultOnlyEdgeCaseTriggered)
    ) {
      setIsErrorState(false);
    }
  }, [isMapViewEnabled, noRatesAvailableForAnyProperty]);
  let recentlyChecked: any = '';
  useEffect(() => {
    recentlyChecked = localStorage.getItem('recent');
    setRecentlyViewedFlag(recentlyChecked?.includes(propertyID));
  }, []);
  const { isHotelMaxOccupancyExceeded, isHotelUnavailable } = hotelUnavailableOrMaxOccupied(
    currRateNode,
    pointsRateBlock,
    eeoRateBlock,
    isFlexibleDateSearch,
    propertyData?.basicInformation?.openingDate
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleTooltipClick = (event: any): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      setPopupOpenState(true);
      if (handlePopUpOpen) {
        handlePopUpOpen(true);
      }
    }
  };
  const currentViewIsMobile = CommonUtils.isOnlyMobileView();
  const currentViewIsTab = CommonUtils.isTabletView();
  eventUtil.on('openTooltipPopup', data => {
    setPopupOpenState(data);
  });
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onCancel = () => {
    setPopupOpenState(false);
    if (handlePopUpOpen) {
      handlePopUpOpen(false);
    }
  };

  /**
   * get the distance in miles/km based on the locale
   */

  const hotelDistance = getCalculatedDistance(
    isFlexibleDateSearch ? propertyCardData?.distance : propertyCardData?.node?.distance,
    currentLocale !== hardCodedAllLocale?.en,
    currentLocale
  );

  const openModal = async (propertyID: string) => {
    fetchAndSetSelectedPropertyData(
      setSearchResultsState,
      ratesData?.ratesData,
      propertyID,
      isFlexibleDateSearch,
      continueCtaProperty
    );
    const pageNameURL = `${host}${addSubDirectoryPrefix(NAVIGATION_URL_CONSTANTS.SM_HOTEL_QUICK_VIEW_URL)}`;
    hqvDispatch({ type: HQV_ACTIONS.PROPERTY_SESSION_DATA, payload: sessionData });
    hqvDispatch({ type: HQV_ACTIONS.PROPERTY_IDENTITY, payload: propertyID });
    hqvDispatch({ type: HQV_ACTIONS.MODAL_OPEN_STATE, payload: true });
    hqvDispatch({ type: HQV_ACTIONS.PROPERTY_DISTANCE, payload: hotelDistance || '' });
    window._satellite['track']('hotelquickview', { pagename: pageNameURL, marsha: propertyID });
    if (bodyRef.current) {
      bodyRef.current.style.height = '100vh';
      bodyRef.current.style.overflow = 'hidden';
    }
    setHQVModalFlag(true);
  };

  const mandatoryFeeTitle =
    pageVal === 'chat'
      ? 'Destination Amenity Fee'
      : constructMandatoryFeeTitle(isResort, isLACountyFee, isDestinationFee, jsonContent);

  const constructReviewsTitle = useMemo(() => {
    return (
      reviewInfo?.stars?.count +
      ' ' +
      jsonContent?.starsLabel +
      ' ' +
      formatNumberByLocale(reviewInfo?.numberOfReviews?.count, currentLocale) +
      ' ' +
      jsonContent?.reviewsLabel
    );
  }, [reviewInfo, jsonContent, currentLocale]);

  const reviewsRedirectionURL = useRedirectionRules(
    brandCode,
    propertyID,
    basicInformation?.name,
    reviewsRedirectionVarValue,
    currentLocale,
    seoNickName
  );

  const trcRedirectionURL = useRedirectionRules(
    brandCode,
    propertyID,
    basicInformation?.name,
    trcRedirectionVarValue,
    currentLocale,
    seoNickName
  );

  const trcUrl = disableHotelHeaderAndReviewLinks ? '' : trcRedirectionURL;

  const reviewUrl = disableHotelReviewLinks
    ? ''
    : HWSBrands.includes(brandCode)
    ? trcRedirectionURL
    : reviewsRedirectionURL;
  const [secondaryTitle, setSecondaryTitle] = useState(false);
  /**
   * Set the flag to true if the locale is Korea/Japan
   */
  useEffect(() => {
    if (isJpKoCnLocale(currentLocale)) {
      setSecondaryTitle(true);
    } else {
      setSecondaryTitle(false);
    }
  }, [currentLocale]);

  const checkForTextDescriptor = () => {
    if (secondaryTitle && !jsonContent.disableTextDescriptor) {
      return true;
    } else if (!secondaryTitle && !jsonContent.disableTextDescriptor) {
      if (nameInDefaultLanguage === basicInformation.name) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <Styled>
      <>
        {popupOpenState && (
          <Modal
            secondaryClassName={clsx('popup-width', 'custom-position')}
            show={true}
            handleBlur={true}
            popupOpenState={popupOpenState}
            setPopupOpenState={setPopupOpenState}
            role="dialog"
            labelledBy="tooltip-modal"
            modalId="tooltip-modal"
            disableScrollOnBody={true}
            flexLayout={true}
          >
            <div className="tooltip-popup-wrapper">
              <Modal.Header
                className="custom-header-font"
                labelText={toolTipTitle}
                popupHeaderOnCLoseFunc={onCancel}
                popupCloseClassName="popup-close-button"
                flexLayout={true}
              ></Modal.Header>
              <Modal.Body className="custom-heights" flexLayout={true}>
                <div className="tooltip-main-wrapper" tabIndex={0} role="document">
                  Includes:
                  <div className="tooltip-main-content">
                    <ul className="custom-ul-props">
                      {toolTipList?.map((item: string) => {
                        return <li className="custom-list">{item?.replace('•', '')}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer
                setFeatureSelected={setFeatureSelected}
                viewRateLabel={
                  continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                }
                viewRatesURL={constructAdfOrRlmURL(
                  NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                  NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_ADF_URL,
                  NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_URL,
                  isFlexibleDateSearch,
                  propertyID,
                  currentCurrency,
                  includeTaxesAndFees
                )}
                className="color-scheme3 row-reverse"
                fromToolTip={true}
                tooltipCtaClickHandler={() =>
                  handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID) as undefined
                }
                flexLayout={true}
              ></Modal.Footer>
            </div>
          </Modal>
        )}

        <div
          onMouseEnter={(): void => handlePropertyCardHover(propertyCardData)}
          onMouseLeave={handlePropertyCardUnhover}
          className={clsx(
            pageVal === 'chat' ? 'p-2' : 'px-0',
            'property-card-container',
            'container',
            isMapViewEnabled ? `map-view` : ``
          )}
          data-testid={'cardContainer-testid'}
          key={`property-card-container-${propertyID}`}
        >
          <div className="image-gallery-container">
            <div className="hotel-image-container">
              <ImageCarouselComponent
                imageList={media?.primaryImage?.edges}
                propertyID={propertyID}
                isFullyRenovated={isFullyRenovated}
                isRecentlyRenovated={isRecentlyRenovated}
                hasRenovatedRooms={hasRenovatedRooms}
                newLobby={newLobby}
                newProperty={newProperty}
                idx={idx}
                brandCode={brandCode}
                recentlyViewedFlag={recentlyViewedFlag}
                brandImageData={(basicInformation?.brand?.photos || [])[0]?.content}
                hotelName={basicInformation?.name}
                seoNickname={seoNickName}
                disableHeartIcon={propertyHandleStaleError}
                isBrandLogoPresent={basicInformation?.brand?.id && basicInformation?.hasUniquePropertyLogo === false}
                pageVal={pageVal}
              />
            </div>
            {basicInformation?.brand?.id && basicInformation?.hasUniquePropertyLogo === false ? (
              <div
                className={clsx(
                  featureFlagLogo?.experience_mcom_logo_automation ? 'hotel-brand-logo-container' : '',
                  'hotel-brand-container',
                  'ml-3'
                )}
              >
                {featureFlagLogo?.experience_mcom_logo_automation ? (
                  <LogoContainer
                    brand={basicInformation?.brand?.id}
                    aspectRatio={'4:2'}
                    width={124}
                    height={45}
                    alignment={'Bottom Left'}
                    isLink={false}
                    color={'background-aware'}
                    backgroundColor={LogoContainerBackgroundColor.Inverse}
                    aspectMode={Types.AspectMode.xMinYMid}
                    brandFullName={basicInformation?.brand?.name}
                  />
                ) : (
                  <div
                    className={`icon-inverse brand-logo-container brand-logo-${basicInformation?.brand?.id?.toUpperCase()}`}
                    aria-label={`${
                      basicInformation?.brand?.id.toUpperCase() === studioResCode
                        ? studisResCodeAriaLabel
                        : basicInformation?.brand?.name
                    } ${jsonContent?.brandIconLabel}`}
                    tabIndex={0}
                    role="img"
                  />
                )}
              </div>
            ) : (
              ''
            )}
          </div>
          <div className={clsx('color-scheme1 text-container', pageVal === 'chat' ? 'px-4 py-2' : '')}>
            <div
              className={clsx('details-container', pageVal === 'chat' ? 'p-0 m-0' : '')}
              onClick={() => {
                pageVal === 'chat' && onOpenHotelPanel && onOpenHotelPanel(propertyData, propertyID);
              }}
            >
              {basicInformation?.name && (
                <>
                  {!HWSBrands.includes(brandCode) && (
                    <button
                      className={clsx(
                        disableHotelHeaderAndReviewLinks ? 'disableLinks ' : '',
                        isMapViewEnabled
                          ? clsx(
                              getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                              ' title-container hqv-modal-opener analytics-click custom_click_track '
                            )
                          : clsx(
                              getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m'),
                              ' title-container hqv-modal-opener analytics-click custom_click_track '
                            )
                      )}
                      {...{
                        custom_click_track_value: `${clickTrackingLoc}| ${basicInformation?.name} |internal`,
                      }}
                      onClick={() => openModal(propertyID)}
                      aria-label={basicInformation?.name}
                      ref={propertyNameRef}
                    >
                      <div
                        className={
                          isMapViewEnabled
                            ? clsx(
                                getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                                isJpKoCnLocale(currentLocale) && nameInDefaultLanguage && 'title-primary-mob'
                              )
                            : clsx(
                                pageVal === 'chat' && 'title-ellipses',
                                getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m'),
                                checkForTextDescriptor() &&
                                  getClassForBreakpoint(
                                    breakpoint,
                                    'title-ellipses',
                                    'title-ellipses',
                                    'title-primary-mob'
                                  )
                              )
                        }
                      >
                        {basicInformation?.name}
                      </div>
                      {nameInDefaultLanguage !== basicInformation?.name && secondaryTitle && (
                        <div
                          className={clsx(
                            disableHotelHeaderAndReviewLinks ? 'disableLinks ' : '',
                            'py-2',
                            isMapViewEnabled
                              ? clsx(
                                  getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                                  'title-secondary-mob'
                                )
                              : clsx(
                                  getClassForBreakpoint(
                                    breakpoint,
                                    't-subtitle-xl title-ellipses',
                                    't-subtitle-l title-ellipses',
                                    't-subtitle-m title-secondary-mob'
                                  ),
                                  'title-secondary',
                                  pageVal === 'chat' ? 'title-chat' : ''
                                )
                          )}
                        >
                          {nameInDefaultLanguage}
                        </div>
                      )}
                      {nameInDefaultLanguage === basicInformation?.name && !jsonContent?.disableTextDescriptor && (
                        <div
                          className={clsx(
                            disableHotelHeaderAndReviewLinks ? 'disableLinks ' : '',
                            'text-descriptor py-1',
                            isMapViewEnabled
                              ? clsx(
                                  getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                                  'title-secondary-mob'
                                )
                              : clsx(
                                  getClassForBreakpoint(
                                    breakpoint,
                                    't-subtitle-xl title-ellipses',
                                    't-subtitle-l title-ellipses',
                                    't-subtitle-m title-secondary-mob'
                                  ),
                                  'title-secondary',
                                  pageVal === 'chat' ? 'title-chat' : ''
                                )
                          )}
                        >
                          {jsonContent?.descriptorSearchLabel}
                        </div>
                      )}
                    </button>
                  )}
                  {HWSBrands.includes(brandCode) && (
                    <a
                      href={trcUrl}
                      target="_blank"
                      rel="noreferrer"
                      className={clsx(
                        disableHotelHeaderAndReviewLinks ? 'disableLinks ' : ' ',
                        isMapViewEnabled
                          ? clsx(
                              getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                              ' title-container analytics-click custom_click_track '
                            )
                          : clsx(
                              getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m'),
                              ' title-container analytics-click custom_click_track '
                            )
                      )}
                      {...{
                        custom_click_track_value: `${clickTrackingLoc}| Property Title: ${basicInformation?.name}|internal`,
                      }}
                      aria-label={basicInformation?.name}
                    >
                      <div
                        className={
                          isMapViewEnabled
                            ? clsx(
                                getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                                isJpKoCnLocale(currentLocale) && nameInDefaultLanguage && 'title-primary-mob'
                              )
                            : clsx(
                                getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m'),
                                pageVal === 'chat' && 'title-ellipses',
                                checkForTextDescriptor() &&
                                  getClassForBreakpoint(
                                    breakpoint,
                                    'title-ellipses',
                                    'title-ellipses',
                                    'title-primary-mob'
                                  )
                              )
                        }
                      >
                        {basicInformation?.name}
                      </div>
                      {nameInDefaultLanguage !== basicInformation?.name && secondaryTitle && (
                        <div
                          className={clsx(
                            disableHotelHeaderAndReviewLinks ? 'disableLinks ' : '',
                            'py-2',
                            isMapViewEnabled
                              ? clsx(
                                  getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                                  'title-secondary-mob'
                                )
                              : clsx(
                                  getClassForBreakpoint(
                                    breakpoint,
                                    'title-ellipses t-subtitle-xl',
                                    'title-ellipses t-subtitle-l',
                                    'title-secondary-mob t-subtitle-m'
                                  ),
                                  'title-secondary'
                                )
                          )}
                        >
                          {nameInDefaultLanguage}
                        </div>
                      )}
                      {nameInDefaultLanguage === basicInformation?.name && !jsonContent?.disableTextDescriptor && (
                        <div
                          className={clsx(
                            disableHotelHeaderAndReviewLinks ? 'disableLinks ' : '',
                            'text-descriptor py-1',
                            isMapViewEnabled
                              ? clsx(
                                  getClassForBreakpoint(breakpoint, 't-subtitle-m', 't-subtitle-l', 't-subtitle-m'),
                                  'title-secondary-mob'
                                )
                              : clsx(
                                  getClassForBreakpoint(
                                    breakpoint,
                                    't-subtitle-xl title-ellipses',
                                    't-subtitle-l title-ellipses',
                                    't-subtitle-m title-secondary-mob'
                                  ),
                                  'title-secondary',
                                  pageVal === 'chat' ? 'title-chat' : ''
                                )
                          )}
                        >
                          {jsonContent?.descriptorSearchLabel}
                        </div>
                      )}
                    </a>
                  )}
                </>
              )}
              {(isMapViewEnabled || currentViewIsMobile) &&
                otherPropertyInformation?.isAllInclusive &&
                localeToShowAllInclusiveBadge.includes(currentLocale) && (
                  <Badge
                    badgeVariation={BadgeVariation.Inline}
                    badgeText={jsonContent?.allInclusiveLabel}
                    customClass="property-card-all-inclusive-tag mt-3 mb-2"
                  />
                )}
              <div className="reviews-distance-container">
                {!currentViewIsMobile &&
                  !isMapViewEnabled &&
                  otherPropertyInformation?.isAllInclusive &&
                  localeToShowAllInclusiveBadge.includes(currentLocale) && (
                    <Badge
                      badgeVariation={BadgeVariation.Inline}
                      badgeText={jsonContent?.allInclusiveLabel}
                      customClass="property-card-all-inclusive-tag"
                    />
                  )}
                {!isMax
                  ? reviewInfo?.numberOfReviews?.count > 0 && (
                      <PropertyRatingContainer
                        target="_blank"
                        rel="noreferrer"
                        propertyReviewUrl={reviewUrl}
                        title={constructReviewsTitle}
                        aria-label={constructReviewsTitle}
                        disabled={isReviewCountHidden(currentLocale)}
                        tooltipPosition={
                          isMapViewEnabled || !isViewportS ? TOOLTIP_POSITION.right : TOOLTIP_POSITION.bottom
                        }
                        toolTipContent={CN_RATING_TOOLTIP}
                        className={clsx(
                          ratingContainer,
                          'custom_click_track',
                          getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m'),
                          disableHotelReviewLinks ? 'disableLinks' : ''
                        )}
                        {...{ custom_click_track_value: `${clickTrackingLoc}| Reviews |internal` }}
                      >
                        {reviewInfo?.stars?.count && reviewInfo?.stars?.count !== null && (
                          <div className="col star-container">
                            <div
                              className={clsx(
                                getClassForBreakpoint(breakpoint, 'm-ratings', 'm-ratings', 'm-ratings'),
                                ' ratings-value-container '
                              )}
                            >
                              <div className="m-ratings-stars mr-1">
                                {reviewInfo?.stars?.count && (
                                  <>
                                    {reviewInfo?.stars?.count > 2.5 && (
                                      <span className="star-icon-container icon-alt icon-star-fill" />
                                    )}
                                    {!(reviewInfo?.stars?.count > 2.5) && (
                                      <span className="star-icon-container icon-alt icon-star-half-fill" />
                                    )}
                                  </>
                                )}
                              </div>
                              <span
                                className={
                                  isMapViewEnabled
                                    ? clsx(getMapViewRatingClass(), '  star-number-container mr-1')
                                    : clsx(getListViewRatingClass(), ' star-number-container mr-1')
                                }
                              >
                                {formatNumberByLocale(reviewInfo?.stars?.count, currentLocale)}
                              </span>
                              <PropertyReview
                                isVisible={reviewInfo?.numberOfReviews?.count && !isReviewCountHidden(currentLocale)}
                                className={
                                  isMapViewEnabled
                                    ? clsx(getMapViewRatingClass(), '  review-number-container mr-2')
                                    : clsx(getListViewRatingClass(), ' review-number-container mr-2')
                                }
                              >
                                <div
                                  className={clsx(
                                    'reviews-count-container',
                                    currentViewIsMobile || currentViewIsTab || isMapViewEnabled
                                      ? 't-font-alt-xs'
                                      : 't-font-alt-s'
                                  )}
                                >
                                  ({formatNumberByLocale(reviewInfo?.numberOfReviews?.count, currentLocale)}{' '}
                                  {isMapViewEnabled ? jsonContent.reviewsShortLabel : jsonContent?.reviewsLabel})
                                </div>
                              </PropertyReview>
                            </div>
                          </div>
                        )}
                      </PropertyRatingContainer>
                    )
                  : null}
                {/* hide/show distance on property card based on hotellist param */}
                {enableHotelList() === true
                  ? ''
                  : // To display distance irrespective of reviews present or not (FSD-62793)
                    (isFlexibleDateSearch ? propertyCardData?.distance >= 0 : propertyCardData?.node?.distance >= 0) &&
                    (isFlexibleDateSearch
                      ? propertyCardData?.distance !== null
                      : propertyCardData?.node?.distance !== null) && (
                      <div className="distance-section">
                        {!isMax && reviewInfo?.numberOfReviews?.count > 0 ? (
                          <div
                            className={clsx(
                              currentViewIsMobile || currentViewIsTab || isMapViewEnabled
                                ? 't-font-alt-xs'
                                : 't-font-alt-s',
                              'divider-section',
                              'px-2'
                            )}
                          >
                            |
                          </div>
                        ) : (
                          ''
                        )}
                        <div
                          className={clsx(
                            getClassForBreakpoint(breakpoint, 'm-icon-text', 'm-icon-text', 'm-icon-text'),
                            ' distance-container'
                          )}
                        >
                          <span
                            className={clsx(
                              getClassForBreakpoint(breakpoint, 'icon-xs', 'icon-xs', 'icon-xs'),
                              ' icon-location icon-xs'
                            )}
                          ></span>
                          <span
                            className={
                              isMapViewEnabled &&
                              (currentLocale === hardCodedAllLocale?.de || currentLocale === hardCodedAllLocale?.zhTW)
                                ? clsx(
                                    getClassForBreakpoint(
                                      breakpoint,
                                      't-font-alt-xs',
                                      't-font-alt-xs',
                                      't-font-alt-xs'
                                    ),
                                    ' distance-value text-overflow-ellipsis'
                                  )
                                : isMapViewEnabled &&
                                  (currentLocale !== hardCodedAllLocale?.de ||
                                    currentLocale !== hardCodedAllLocale?.zhTW)
                                ? clsx(
                                    getClassForBreakpoint(
                                      breakpoint,
                                      't-font-alt-xs',
                                      't-font-alt-xs',
                                      't-font-alt-xs'
                                    ),
                                    ' distance-value',
                                    'distance-ellipsis'
                                  )
                                : clsx(
                                    getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-xs', 't-font-alt-xs'),
                                    ' distance-value'
                                  )
                            }
                            // tabIndex={0}
                          >
                            {hotelDistance} {jsonContent?.unitFromDestinationLabel}
                          </span>
                        </div>
                      </div>
                    )}
              </div>
              <div
                className={clsx(
                  pageVal === 'chat' ? 'mt-2 mb-2' : '',
                  getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-xs', 't-font-alt-xs'),
                  ' description-container ',
                  `${
                    showStrikeThroughPrice &&
                    (isMandatoryFeeAvailable || (finalPrice && finalPrice?.split('')?.length > 3)) &&
                    'description-ellipsis'
                  }`
                )}
                //tabIndex={0}
              >
                {basicInformation?.descriptions
                  ?.filter(
                    (description: { type: { enumCode: string } }) =>
                      description?.type?.enumCode === descriptionToDisplayOnPropertyCard
                  )
                  .map((description: { text: string; type: { code: string } }, index: number) => (
                    <span key={`basic-info-${description?.type?.code ? description?.type?.code : index}`}>
                      {description?.text}
                    </span>
                  ))}
              </div>
              {pageVal !== 'chat' && !HWSBrands.includes(brandCode) && (
                <button
                  onClick={() => openModal(propertyID)}
                  aria-label={jsonContent?.goToViewHotelDetailsLabel}
                  className="m-link-tertiary-button view-hotel-details-section analytics-click custom_click_track hqv-modal-opener "
                  {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Details Page |internal` }}
                  tabIndex={0}
                >
                  {jsonContent?.viewDetailsLabel}
                </button>
              )}
              {pageVal !== 'chat' && HWSBrands.includes(brandCode) && (
                <a
                  href={trcRedirectionURL}
                  target="_blank"
                  rel="noreferrer"
                  className={clsx(
                    'view-hotel-details-section',
                    'm-link-tertiary-button-external',
                    'custom_click_track'
                  )}
                  {...{
                    custom_click_track_value: `${clickTrackingLoc}| Property Title: ${basicInformation?.name}|internal`,
                  }}
                  tabIndex={0}
                  aria-label={jsonContent.goToViewHotelDetailsLabel}
                >
                  {jsonContent.viewDetailsLabel}
                </a>
              )}
            </div>
            <div className="lower-section">
              <div className="horizontal-line"></div>
              <div className="edge-cases">
                {!isErrorState && noRatesAvailableForAnyProperty && !isAdultOnlyEdgeCaseTriggered && (
                  <>
                    <div className="error-state-triggered edge-case hotel-unavailable">
                      <a
                        href={constructAdfOrRlmURL(
                          NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                          NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_ADF_URL,
                          NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_URL,
                          isFlexibleDateSearch,
                          propertyID,
                          currentCurrency,
                          includeTaxesAndFees
                        )}
                        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                        onClick={() => {
                          handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID);
                          updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch);
                        }}
                        className="view-rates-button-container analytics-click custom_click_track"
                        {...{ custom_click_track_value: `${clickTrackingLoc}| View Rates |internal` }}
                        aria-label={
                          continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                        }
                      >
                        <button
                          type="button"
                          className="m-button-s m-button-primary view-rates-button"
                          tabIndex={-1}
                          aria-label={
                            continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                          }
                        >
                          {continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel}
                        </button>
                      </a>
                    </div>
                    {(edgeCaseTriggered = true)}
                  </>
                )}
                {isFutureDate && (isFlexibleDateSearch || !isRatesPresent) && !edgeCaseTriggered && (
                  <div className={clsx(isViewportL ? 't-font-alt-m' : 't-font-alt-s', 'edge-case', 'opening-soon')}>
                    <span
                      className={clsx(
                        `${
                          isFlexibleDateSearch
                            ? `flexi-opening-soon ${isMapViewEnabled ? 'map-view-show-availability' : ''}`
                            : `${isMapViewEnabled ? 'map-view-show-availability-text' : ''}`
                        }`,
                        'opening-soon-font'
                      )}
                    >
                      {formatOpeningSoonDate(
                        jsonContent.openingSoonLabel,
                        openingDate,
                        jsonContent?.openingSoonDateFormat,
                        currentLocale
                      )}
                    </span>
                    {isHotelBookable && (
                      <a
                        data-testid={'show-available-testid'}
                        href={constructAdfOrRlmURL(
                          NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                          '',
                          NAVIGATION_URL_CONSTANTS?.SM_AVAILABILITY_URL,
                          false,
                          propertyID,
                          currentCurrency,
                          includeTaxesAndFees
                        )}
                        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                        onClick={() => handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID)}
                        className="cta-button analytics-click custom_click_track view-availability-section"
                        {...{ custom_click_track_value: `${clickTrackingLoc}| View Other Dates Button |internal` }}
                        // tabIndex={-1}
                        tabIndex={0}
                        role="link"
                      >
                        <button type="button" className="m-button-s m-button-secondary show-availability-button">
                          {continueCtaProperty === propertyID
                            ? jsonContent?.continueText
                            : jsonContent.showAvailabilityLabel}
                        </button>
                      </a>
                    )}
                    {(edgeCaseTriggered = true)}
                  </div>
                )}
                {!isFlexibleDateSearch &&
                  isHotelCodeUnavailable &&
                  !edgeCaseTriggered &&
                  !noRatesAvailableForAnyProperty && (
                    <>
                      <div className="edge-case hotel-unavailable">
                        <div
                          className={clsx(
                            getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-s', 't-font-alt-xs'),
                            'unavailable-text',
                            'max-occupancy-soldout-case'
                          )}
                        >
                          {jsonContent?.soldOutLabel}
                        </div>
                        <a
                          href={constructAdfOrRlmURL(
                            NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                            '',
                            NAVIGATION_URL_CONSTANTS?.SM_AVAILABILITY_URL,
                            false,
                            propertyID,
                            currentCurrency,
                            includeTaxesAndFees
                          )}
                          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                          onClick={() => handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID)}
                          className="cta-button analytics-click custom_click_track view-availability-section"
                          {...{ custom_click_track_value: `${clickTrackingLoc}| View Other Dates Button |internal` }}
                          // tabIndex={-1}
                          tabIndex={0}
                          role="link"
                        >
                          <button type="button" className="m-button-s m-button-secondary show-availability-button">
                            {continueCtaProperty === propertyID
                              ? jsonContent?.continueText
                              : jsonContent.showAvailabilityLabel}
                          </button>
                        </a>
                      </div>
                      {(edgeCaseTriggered = true)}
                    </>
                  )}
                {isHotelBookable &&
                  isHotelUnavailable &&
                  !edgeCaseTriggered &&
                  !isFlexibleDateSearch &&
                  !isAdultOnlyEdgeCaseTriggered &&
                  !isHotelMaxOccupancyExceeded &&
                  !noRatesAvailableForAnyProperty && (
                    <>
                      <div className="edge-case hotel-unavailable">
                        <div
                          className={clsx(
                            getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-s', 't-font-alt-s'),
                            'unavailable-text',
                            'non-max-occupanyc-soldout-case'
                          )}
                        >
                          {isSpecialRateSearch ? jsonContent.rateUnavailableLabel : jsonContent?.soldOutLabel}&nbsp;
                        </div>
                        <a
                          href={constructAdfOrRlmURL(
                            NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                            '',
                            NAVIGATION_URL_CONSTANTS?.SM_AVAILABILITY_URL,
                            false,
                            propertyID,
                            currentCurrency,
                            includeTaxesAndFees
                          )}
                          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                          onClick={() => handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID)}
                          className="cta-button analytics-click custom_click_track view-availability-section"
                          {...{ custom_click_track_value: `${clickTrackingLoc}| View Other Dates Button |internal` }}
                          tabIndex={0}
                          role="link"
                        >
                          <button type="button" className="m-button-s m-button-secondary show-availability-button">
                            {continueCtaProperty === propertyID
                              ? jsonContent?.continueText
                              : jsonContent.showAvailabilityLabel}
                          </button>
                        </a>
                      </div>
                      {(edgeCaseTriggered = true)}
                    </>
                  )}
                {!isHotelBookable && !edgeCaseTriggered && (
                  <div
                    className={clsx(
                      getClassForBreakpoint(breakpoint, 't-font-alt-m', 't-font-alt-s', 't-font-alt-s'),
                      ' edge-case call-to-book '
                    )}
                  >
                    {jsonContent.callToBookLabel}
                    {(edgeCaseTriggered = true)}
                  </div>
                )}
              </div>
              <div className="adult-only-edge-cases">
                {adultsOnlyPropertyFlag && childCount > 0 && !edgeCaseTriggered && (
                  <>
                    <div
                      className={clsx(
                        't-font-alt-s',
                        'adult-only-property',
                        isMapViewEnabled ? 'adult-edge-case' : 'edge-case',
                        currentLocale === hardCodedAllLocale.de || currentLocale === hardCodedAllLocale.zhTW
                          ? 'adult-edge-case-de'
                          : ''
                      )}
                    >
                      <div className="adult-only-message">{jsonContent.adultsOnlyMessageLabel}</div>
                      <div className="remove-children-message">{` ${jsonContent.removeChildrenMessage}`}</div>
                    </div>
                    {(edgeCaseTriggered = true)}
                  </>
                )}
              </div>
              {isHotelMaxOccupancyExceeded && !edgeCaseTriggered && (
                <div className={clsx(`t-font-alt-s my-2 ${isMapViewEnabled ? 'map-max-occupancy' : 'max-occupancy'}`)}>
                  <div className={clsx(`max-guests ${isMapViewEnabled ? 'map-max-guests mx-3' : ''}`)}>
                    <span className="maximum-guest-label">{jsonContent?.maximumGuestsExceededLabel}</span>{' '}
                    <span className="edit-guest-label">{jsonContent?.editGuestsOrRoomsLabel}</span>
                  </div>
                </div>
              )}
              {!isHotelUnavailable &&
                !isHotelMaxOccupancyExceeded &&
                !edgeCaseTriggered &&
                !noRatesAvailableForAnyProperty && (
                  <div
                    className={clsx(
                      'price-container',
                      isMapViewEnabled &&
                        (currentLocale === hardCodedAllLocale.de || currentLocale === hardCodedAllLocale.zhTW)
                        ? 'price-de-container-map-view'
                        : ''
                    )}
                  >
                    {propertyCardData && !isFlexibleDateSearch && (
                      <div
                        className={`price-sub-section ${
                          !isMapViewEnabled &&
                          (currentViewIsMobile || currentViewIsTab) &&
                          'la-county-section-list-view'
                        }`}
                      >
                        <PropertyCardPriceSection
                          propertyCardData={propertyCardData}
                          recentlyviewedRibbon={handlePropertyClicked}
                          setShowStrikeThroughPrice={setShowStrikeThroughPrice}
                          showStrikeThroughPrice={showStrikeThroughPrice}
                          setFinalPrice={setFinalPrice}
                          pageNumber={pageNumber}
                          idx={idx}
                          handleTooltipClick={handleTooltipClick}
                          toolTipList={toolTipList}
                        />
                        {/* Mandatory Amenities Fees section */}
                        {isMandatoryFeeAvailable && mandatoryFeeTitle && !totalPrice?.amount && !pointsValue && (
                          <>
                            {!isMapViewEnabled && !currentViewIsMobile && !currentViewIsTab && (
                              <div
                                tabIndex={0}
                                title={mandatoryFeeTitle}
                                role="term"
                                className="mandatory-fee-section"
                                onKeyDown={(e): void => handleTooltipClick(e)}
                                aria-live="off"
                              >
                                <span
                                  onClick={(e): void => handleTooltipClick(e)}
                                  className={clsx(
                                    'm-link-icon-button-info',
                                    'custom-info-list',
                                    'analytics-click',
                                    'custom_click_track',
                                    !toolTipList?.length ? 'remove-info-icon' : ''
                                  )}
                                  {...{
                                    custom_click_track_value: `${clickTrackingLoc}| Mandatory Fee Tooltip Button |internal`,
                                  }}
                                >
                                  {jsonContent?.includesLabel}{' '}
                                  {getPriceByDecimalPoint(
                                    newMandatFee?.amount,
                                    newMandatFee?.decimalPoint,
                                    searchQueryState,
                                    currentLocale,
                                    newMandatFee?.currency
                                  )}{' '}
                                  {currentCurrency !== DefaultValue ? currentCurrency : newMandatFee?.currency}{' '}
                                  {mandatoryFeeTitle}
                                </span>
                              </div>
                            )}
                            {!isMapViewEnabled && currentViewIsMobile && (
                              <div
                                tabIndex={0}
                                role="generic"
                                className="mandatory-fee-section-list-view"
                                onKeyDown={(e): void => handleTooltipClick(e)}
                              >
                                <div className="includes-fee">
                                  {jsonContent?.includesLabel}{' '}
                                  {getPriceByDecimalPoint(
                                    newMandatFee?.amount,
                                    newMandatFee?.decimalPoint,
                                    searchQueryState,
                                    currentLocale,
                                    newMandatFee?.currency
                                  )}{' '}
                                  {currentCurrency !== DefaultValue ? currentCurrency : newMandatFee?.currency}
                                </div>
                                <div>
                                  <span
                                    onClick={(e): void => handleTooltipClick(e)}
                                    className={clsx(
                                      'm-link-icon-button-info',
                                      'custom-info-map',
                                      !toolTipList?.length ? 'remove-info-icon' : ''
                                    )}
                                    {...{
                                      custom_click_track_value: `${clickTrackingLoc}| Mandatory Fee Tooltip Button |internal`,
                                    }}
                                  >
                                    {mandatoryFeeTitle}
                                  </span>
                                </div>
                              </div>
                            )}
                            {!isMapViewEnabled && currentViewIsTab && (
                              <div
                                role="generic"
                                className="mandatory-fee-section-list-view"
                                tabIndex={0}
                                onKeyDown={(e): void => handleTooltipClick(e)}
                              >
                                <div className="includes-fee">
                                  {jsonContent?.includesLabel}{' '}
                                  {getPriceByDecimalPoint(
                                    newMandatFee?.amount,
                                    newMandatFee?.decimalPoint,
                                    searchQueryState,
                                    currentLocale,
                                    newMandatFee?.currency
                                  )}{' '}
                                  {currentCurrency !== DefaultValue ? currentCurrency : newMandatFee?.currency}
                                </div>
                                <div>
                                  <span
                                    onClick={(e): void => handleTooltipClick(e)}
                                    className={clsx(
                                      'm-link-icon-button-info',
                                      'custom-info-map',
                                      'analytics-click',
                                      'custom_click_track',
                                      !toolTipList?.length ? 'remove-info-icon' : ''
                                    )}
                                    {...{
                                      custom_click_track_value: `${clickTrackingLoc}| Mandatory Fee Tooltip Button |internal`,
                                    }}
                                  >
                                    {mandatoryFeeTitle}
                                  </span>
                                </div>
                              </div>
                            )}
                            {isMapViewEnabled && (
                              <div
                                role="generic"
                                className="mandatory-fee-section-list-view"
                                tabIndex={0}
                                onKeyDown={(e): void => handleTooltipClick(e)}
                              >
                                <div className="includes-fee">
                                  {jsonContent?.includesLabel}{' '}
                                  {getPriceByDecimalPoint(
                                    newMandatFee?.amount,
                                    newMandatFee?.decimalPoint,
                                    searchQueryState,
                                    currentLocale,
                                    newMandatFee?.currency
                                  )}{' '}
                                  {currentCurrency !== DefaultValue ? currentCurrency : newMandatFee?.currency}
                                </div>

                                <div>
                                  <span
                                    onClick={(e): void => handleTooltipClick(e)}
                                    className={clsx(
                                      'm-link-icon-button-info',
                                      'custom-info-map',
                                      'analytics-click',
                                      'custom_click_track',
                                      !toolTipList?.length ? 'remove-info-icon' : ''
                                    )}
                                    {...{
                                      custom_click_track_value: `${clickTrackingLoc}| Mandatory Fee Tooltip Button |internal`,
                                    }}
                                  >
                                    {mandatoryFeeTitle}
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    <a
                      href={constructAdfOrRlmURL(
                        NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                        NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_ADF_URL,
                        NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_URL,
                        isFlexibleDateSearch,
                        propertyID,
                        currentCurrency,
                        includeTaxesAndFees
                      )}
                      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                      onClick={() => {
                        handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID);
                        updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch);
                      }}
                      className="view-rates-button-container analytics-click custom_click_track"
                      {...{ custom_click_track_value: `${clickTrackingLoc}| View Rates |internal` }}
                      aria-label={
                        continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                      }
                    >
                      <button
                        type="button"
                        className="m-button-s m-button-primary view-rates-button"
                        tabIndex={-1}
                        aria-label={
                          continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                        }
                      >
                        {continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel}
                      </button>
                    </a>
                    {(edgeCaseTriggered = true)}
                  </div>
                )}
              {/* in case of hotel rates block is unavailable and its a flexible or too many properties then render this part */}
              {isHotelUnavailable &&
                isFlexibleDateSearch &&
                isHotelBookable &&
                !isFutureDate &&
                !noRatesAvailableForAnyProperty && (
                  <div
                    className={clsx(
                      'price-container',
                      isMapViewEnabled &&
                        (currentLocale === hardCodedAllLocale.de || currentLocale === hardCodedAllLocale.zhTW)
                        ? 'price-de-container-map-view'
                        : ''
                    )}
                  >
                    <a
                      href={constructAdfOrRlmURL(
                        NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
                        NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_ADF_URL,
                        NAVIGATION_URL_CONSTANTS?.SM_VIEW_RATES_URL,
                        isFlexibleDateSearch,
                        propertyID,
                        currentCurrency,
                        includeTaxesAndFees
                      )}
                      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                      onClick={() => {
                        handlePropertyClicked(recentlyViewed, setRecentlyViewed, propertyID);
                        updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch);
                      }}
                      className="view-rates-button-container analytics-click custom_click_track"
                      {...{ custom_click_track_value: `${clickTrackingLoc}| View Rates |internal` }}
                      aria-label={
                        continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                      }
                    >
                      <button
                        type="button"
                        className="m-button-s m-button-primary view-rates-button"
                        tabIndex={-1}
                        aria-label={
                          continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel
                        }
                      >
                        {continueCtaProperty === propertyID ? jsonContent?.continueText : jsonContent?.viewRateLabel}
                      </button>
                    </a>
                    {(edgeCaseTriggered = true)}
                  </div>
                )}
            </div>
          </div>
        </div>
      </>
    </Styled>
  );
};
